module.exports = __webpack_public_path__ + "img/Postmodernisme_Tida_og_samfunnsforhold2.7064d9ff.jpg";